module.exports = __webpack_public_path__ + "images/manifestum/book.357158c9.svg";